// Deliberately not the soak's `legacyDashboardOptOut`, so a browser that clicked
// "Go back" returns to the rebrand with nothing to clear. Only the legacy specs
// set this now; U21 removes it with the toggle.
export const LEGACY_DASHBOARD_TREE_KEY = "legacyDashboardTree";

export const shouldMountLegacyTree = (): boolean => {
  try {
    return localStorage.getItem(LEGACY_DASHBOARD_TREE_KEY) === "true";
  } catch {
    return false;
  }
};
